import { motion } from "framer-motion";
import { FileText, Download } from "lucide-react";

export default function Malla({ 
  malla, 
  mallaCurricular, 
  titleMallaCurricular, 
  mallaCurricular1, 
  titleMallaCurricular1 
}) {
  
  const processContent = (html) => {
    if (!html) return "";
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    doc.querySelectorAll("img").forEach((img) => {
      const src = img.getAttribute("src");
      if (src && !src.startsWith("http")) {
        img.setAttribute(
          "src",
          `https://be-ofertas.utpl.edu.ec/${src.replace(/^\/+/, "")}`,
        );
      }
    });

    return doc.body.innerHTML;
  };

  return (
    <section className="pt-6">
      <div className="max-w-5xl mx-auto px-6">
        <motion.div className="relative overflow-hidden rounded-3xl">
          <div className="relative z-10 p-8 lg:p-12">
            
            {/* Header */}
            <div className="flex items-center gap-4 mb-6">
              <div>
                <h2 className="font-bold ">Malla curricular</h2>
              </div>
            </div>

            {/* Contenido HTML de la Malla (Solo si existe) */}
            {malla && (
              <div
                className="
                  rounded-2xl bg-slate-50 border border-slate-200 p-8 prose prose-lg max-w-none
                  prose-headings:text-slate-900 prose-p:text-slate-700 prose-strong:text-[#004270]
                  [&_p]:leading-8 [&_ul]:list-none [&_ul]:pl-0 [&_ul]:space-y-0 [&_li]:relative 
                  [&_li]:pl-8 [&_li]:py-2 [&_li]:border-b [&_li]:border-slate-200 [&_li]:leading-7 
                  [&_li]:transition [&_li::before]:hidden [&_li:last-child]:border-b-0
                "
                dangerouslySetInnerHTML={{
                  __html: processContent(malla),
                }}
              />
            )}

            {/* Sección de PDFs */}
            <div className="flex flex-col gap-4 mt-8">
              {/* Primer PDF */}
              {mallaCurricular && (
                <PdfCard 
                  url={mallaCurricular} 
                  title={titleMallaCurricular || "Descargar malla curricular"} 
                />
              )}

              {/* Segundo PDF */}
              {mallaCurricular1 && (
                <PdfCard 
                  url={mallaCurricular1} 
                  title={titleMallaCurricular1 || "Descargar malla curricular alternativa"} 
                />
              )}
            </div>

          </div>
        </motion.div>
      </div>
    </section>
  );
}

// Subcomponente reutilizable para evitar duplicar código de las tarjetas PDF
function PdfCard({ url, title }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-6">
        <div className="flex gap-4">
          <div className="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center shrink-0">
            <FileText size={24} className="text-[#004270]" />
          </div>

          <div>
            <h3 className="font-semibold text-slate-900">
              {title}
            </h3>
            <p className="text-sm text-slate-600 mt-1">
              Consulta el documento completo con la planificación académica del programa.
            </p>
          </div>
        </div>

        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 rounded-xl bg-[#004270] px-6 py-3 text-white font-semibold hover:bg-[#00345a] transition white-space-nowrap"
        >
          <Download size={18} />
          Descargar PDF
        </a>
      </div>
    </div>
  );
}